
export default () => ({
    loading: true,
    experiences: [],
    currentExperience: null
})
